<div class="main-container">
  <section class="top-section">
    <go-back class="on-mobil" (click)="back()"></go-back>
    <cp-logo></cp-logo>
  </section>
  <section class="back-home-section">
    <go-back class="desktop" (click)="back()"></go-back>
  </section>

  <div class="flow-container">
    <div class="">
      <section class="get-password-container" [formGroup]="form">
        <h1>Get your password</h1>
        <h3>You will receive a code to create a new password.</h3>
        <div class="input-container">
          <label for="">Email</label>
          <gbui-input
            placeholder="Enter your email"
            simple
            formControlName="email"
          ></gbui-input>
          <label
            class="scale-up-ver-top"
            *ngIf="
              !form.controls['email'].valid && form.controls['email'].touched
            "
          >
            Invalid email
          </label>
        </div>
        <!-- <p for="">Review your email*</p> -->
        <gbui-button
          [busy]="sendEmailLoading$ | async"
          [disabled]="form.invalid"
          class="buttons-outline"
          type="submit"
          (click)="sendEmail()"
        >
          Send
        </gbui-button>
      </section>
    </div>
  </div>
</div>
